export default function USPBlock() {
  const usps = [
    {
      icon: 'ri-price-tag-3-line',
      title: 'Vaste prijs mogelijk',
      description: 'Altijd duidelijke afspraken vooraf, geen onverwachte kosten.'
    },
    {
      icon: 'ri-24-hours-line',
      title: '24/7 beschikbaar',
      description: 'Ook voor nachtvluchten en vroege check-ins.'
    },
    {
      icon: 'ri-car-line',
      title: 'Comfortabele auto\'s',
      description: 'Ruimte voor bagage, schoon en representatief.'
    },
    {
      icon: 'ri-time-line',
      title: 'Altijd op tijd',
      description: 'Wij plannen ruim en houden rekening met verkeer.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Intro Text */}
        <div className="max-w-4xl mx-auto mb-16 text-center">
          <p className="text-lg text-slate-700 leading-relaxed mb-6">
            Utrecht Airport Taxi is gespecialiseerd in comfortabel vervoer van en naar alle luchthavens. Of het nu gaat om een vroege ochtendvlucht, een late aankomst of een zakelijke reis: wij zorgen dat je ontspannen en op tijd reist.
          </p>
          <p className="text-lg text-slate-700 leading-relaxed mb-6">
            Wij rijden dagelijks van Utrecht naar Schiphol, Eindhoven Airport, Rotterdam The Hague Airport en Brussels Airport. Je wordt opgehaald op het afgesproken tijdstip en reist in een nette, ruime auto met een professionele chauffeur.
          </p>
          <p className="text-lg text-slate-700 leading-relaxed">
            Reserveren is eenvoudig en snel. Voor veel ritten kunnen we vooraf een vaste prijs afspreken, zodat je nooit voor verrassingen komt te staan.
          </p>
        </div>

        {/* USP Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {usps.map((usp, index) => (
            <div 
              key={index}
              className="bg-slate-50 rounded-xl p-8 text-center hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${usp.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {usp.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {usp.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
